/**
 * Created by edgar.torosyan on 8/3/17.
 * @deprecated use GridType from idm-dynamic-layout-interpreter
 */
export var GridType;
(function (GridType) {
    GridType["TABULAR"] = "tabular";
    GridType["FLAT"] = "flat";
})(GridType || (GridType = {}));
//# sourceMappingURL=grid.type.enum.js.map